<template>
  <div class="table-responsive">
    <div style="width: 100%; position: relative;">
      <div v-show="loading" class="applicant-list-loader-overlay">
        <Loader />
      </div>
      <table
        v-if="!loading && !showEmptyMessage"
        class="table"
        style="table-layout: fixed !important; width: 100%;"
      >
        <ApplicantTableHeader
          :showReviewListDate="false"
          :showCheckbox="false"
          :showViaFilter="false"
          :showScoutFilter="false"
          :showStatusFilter="false"
          :showJobFilter="false"
          :disableSort="true"
        />
        <tbody>
          <ApplicantRow
            v-for="(applicant, index) in aiMatchedSeekers"
            v-bind:key="applicant.id"
            :applicant="applicant"
            :applicantIndex="index"
            :rowNumber="index + 1"
            :aiMode="true"
          />
        </tbody>
      </table>
      <div v-if="!loading && showEmptyMessage" class="ai-match-empty text-center">
        AIマッチした登録者はいません。
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicantRow from '@/components/dashboard/applicants/ApplicantRow.vue';
import ApplicantTableHeader from '@/components/dashboard/applicants/ApplicantTableHeader.vue';
import Loader from '@/components/utils/Loader.vue';

export default {
  name: 'AiMatchedList',
  components: { ApplicantRow, ApplicantTableHeader, Loader },
  computed: {
    ...mapGetters({
      aiMatchedSeekers: 'getAiMatchedSeekers',
      loading: 'getAiLoading',
    }),
    showEmptyMessage() {
      return this.aiMatchedSeekers.length === 0;
    },
  },
  methods: {
    ...mapActions({
      loadAutoMatchedSeekers: 'loadAutoMatchedSeekers',
    }),
  },
  created() {
    this.loadAutoMatchedSeekers();
  },
};
</script>

<style scoped>
.ai-match-empty {
  padding: 100px 20px;
  color: #3c3c3c;
  font-size: 14px;
}

.applicant-list-loader-overlay {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
